import { isMacOs } from 'react-device-detect'

export const keyToUse = isMacOs ? 'cmd+shift' : 'ctrl+shift'
